<div
  class="page-skeleton"
  [attr.data-variant]="variant"
  role="status"
  aria-live="polite"
  [attr.aria-label]="'common.loading_page' | t">
  <span class="visually-hidden">{{ 'common.loading_page' | t }}</span>

  <ng-container [ngSwitch]="variant">
    <ng-container *ngSwitchCase="'home'">
      <div class="page-skeleton__hero zt-skeleton" aria-hidden="true"></div>
      <div class="page-skeleton__categories" aria-hidden="true">
        <div class="page-skeleton__category" *ngFor="let slot of categorySlots">
          <span class="page-skeleton__category-media zt-skeleton"></span>
          <span class="page-skeleton__line zt-skeleton"></span>
        </div>
      </div>
      <div class="page-skeleton__trust zt-skeleton" aria-hidden="true"></div>
      <div class="page-skeleton__grid" aria-hidden="true">
        <div class="page-skeleton__card zt-skeleton" *ngFor="let slot of productSlots"></div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'product'">
      <div class="page-skeleton__pdp" aria-hidden="true">
        <div class="page-skeleton__pdp-copy">
          <span class="page-skeleton__line zt-skeleton page-skeleton__line--sm"></span>
          <span class="page-skeleton__line zt-skeleton page-skeleton__line--lg"></span>
          <span class="page-skeleton__line zt-skeleton"></span>
          <span class="page-skeleton__price zt-skeleton"></span>
          <span class="page-skeleton__cta zt-skeleton"></span>
        </div>
        <div class="page-skeleton__pdp-media zt-skeleton"></div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'cms'">
      <div class="page-skeleton__cms" aria-hidden="true">
        <div class="page-skeleton__cms-banner zt-skeleton"></div>
        <div class="page-skeleton__cms-triple">
          <span class="page-skeleton__cms-tile zt-skeleton" *ngFor="let slot of productSlots.slice(0, 3)"></span>
        </div>
      </div>
    </ng-container>

    <div class="page-skeleton__grid" *ngSwitchDefault aria-hidden="true">
      <div class="page-skeleton__card zt-skeleton" *ngFor="let slot of cardSlots"></div>
    </div>
  </ng-container>
</div>
